export default "__VITE_ASSET__CJ5i0LQM__"